import React from 'react';
import * as S from './legalStyles';

const PrivacyContentEn: React.FC = () => (
  <>
    <section style={S.section}>
      <h2 style={S.h2}>1. Purpose of Collecting and Using Personal Information</h2>
      <p style={S.p}>Freematch (the "Company") collects and uses personal information for the following purposes:</p>
      <ul style={S.ul}>
        <li>Membership registration and management: identity verification and maintenance of membership status for member-based services</li>
        <li>Service provision: freelancer-client matching, chat, payment, and other services</li>
        <li>Marketing and advertising: providing personalized ads and event notifications</li>
        <li>Service improvement: improving the service through analysis of usage records</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>2. Personal Information Collected</h2>
      <p style={S.p}>
        <strong>Required:</strong> Email, password, name, nickname<br/>
        <strong>Optional:</strong> Phone number, date of birth, gender, profile image<br/>
        <strong>Automatically collected:</strong> IP address, cookies, service usage records, access logs
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>3. Retention and Use Period of Personal Information</h2>
      <p style={S.p}>
        Personal information is retained until membership withdrawal and destroyed immediately thereafter, except where retention is required by law, in which case it is kept for the following periods:
      </p>
      <ul style={S.ul}>
        <li>Contract and subscription-withdrawal records under the E-Commerce Act: 5 years</li>
        <li>Records of payment and supply of goods: 5 years</li>
        <li>Consumer complaint and dispute resolution records: 3 years</li>
        <li>Access logs: 3 months (Protection of Communications Secrets Act)</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>4. Provision of Personal Information to Third Parties</h2>
      <p style={S.p}>In principle, the Company does not provide users' personal information to outside parties, except in the following cases:</p>
      <ul style={S.ul}>
        <li>Where the user has given prior consent</li>
        <li>Where required by law, or requested by investigative authorities following the procedures and methods prescribed by law</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>5. Outsourcing of Personal Information Processing</h2>
      <p style={S.p}>The Company outsources the processing of personal information as follows in order to provide the Service:</p>
      <ul style={S.ul}>
        <li>Toss Payments Corporation: payment processing</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>6. User Rights and How to Exercise Them</h2>
      <p style={S.p}>
        Users may request to view, correct, delete, or suspend processing of their personal information at any time.
        You may edit this directly on your profile page, or contact us at kunkong.co@gmail.com.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>7. Personal Information Protection Officer & Business Information</h2>
      <p style={S.p}>
        <strong>Officer:</strong> KUNKONG<br/>
        <strong>Email:</strong> kunkong.co@gmail.com<br/>
        <strong>Company Name:</strong> KUNKONG<br/>
        <strong>Representative:</strong> Park Ki-beom<br/>
        <strong>Business Registration No.:</strong> 306-38-75095<br/>
        <strong>Address:</strong> 3F, 3-4 Wangbaesan 1-gil, Hwaseong-si, Gyeonggi-do, Republic of Korea<br/>
        <strong>Phone:</strong> +82 10-6284-2450
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>8. Use of Cookies</h2>
      <p style={S.p}>
        The Company uses cookies to keep users logged in and to improve the Service.
        You may refuse cookies in your browser settings, but this may limit use of some services.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>9. Changes to This Privacy Policy</h2>
      <p style={S.p}>
        This Privacy Policy may change in accordance with laws and internal policy; any changes will be announced on the website.
      </p>
    </section>
  </>
);

export default PrivacyContentEn;
